import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
import { hostedLegalPageAssetsEnabled } from '../../util/legalPageAssets';

export const TOS_ASSET_NAME = 'terms-of-service';
export const PRIVACY_POLICY_ASSET_NAME = 'privacy-policy';

/**
 * Die Registrierungsseite zeigt AGB und Datenschutz in Modals. Beide Modals
 * rendern über `resolve*PageAssetData`, also ohne den Schalter aus dem Repo —
 * dann braucht die Seite die Console-Assets auch nicht zu laden.
 * Siehe PrivacyPolicyPage.duck.js.
 */
export const loadData = (params, search) => dispatch => {
  if (!hostedLegalPageAssetsEnabled()) {
    return Promise.resolve();
  }
  const pageAsset = {
    termsOfService: `content/pages/${TOS_ASSET_NAME}.json`,
    privacyPolicy: `content/pages/${PRIVACY_POLICY_ASSET_NAME}.json`,
  };
  return dispatch(fetchPageAssets(pageAsset, true));
};
